import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerIntegralListDataApi(data) {
  return request({
    url: "web/appConsumerIntegral/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppConsumerIntegralExportDataApi(data) {
  return request({
    url: "web/appConsumerIntegral/exportData",
    method: "post",
    data
  });
}

// 用户积分数据
export function listAppConsumerIntegralListDataApi(data) {
  return request({
    url: "web/appConsumerIntegral/listSelectData",
    method: "post",
    data
  });
}